import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { logger } from 'packages';
import MultiCurrencyContainer from './multi-currency-container';
import defineComponent from 'flight';
import initData from 'init-data';

const createFlightListener = (onModalLoad, onModalClose) =>
    function MultiCurrencyFlightListener() {
        this.after('initialize', function() {
            this.on('data:navigation:after-modal-load', onModalLoad);
            this.on('ui:body-container:on-modal-close', onModalClose);
        });
    };

const renderElement = (element, reduxStore, amountInSek) => {
    try {
        ReactDOM.render(
            <Provider store={reduxStore}>
                <MultiCurrencyContainer amountInSek={amountInSek} />
            </Provider>,
            element
        );
    } catch (e) {
        logger(e);
    }
};

const resolveAmountWithoutUnitType = element =>
    element.getAttribute('data-amount-in-sek').replace(/\D/g, '');

const appendToStringOnce = (str, appendix) => {
    const withoutAppendix = str.replace(appendix, '');
    return withoutAppendix + appendix;
};

const renderAllDisplays = reduxStore => {
    const multiCurrencyDisplays = document.querySelectorAll(
        '[data-multi-currency-display]'
    );
    if (multiCurrencyDisplays) {
        for (let i = 0; i < multiCurrencyDisplays.length; i++) {
            const element = multiCurrencyDisplays[i];
            const amountInSek = resolveAmountWithoutUnitType(element);
            element.className = appendToStringOnce(
                element.className,
                ' multi-currency-active'
            );
            renderElement(element, reduxStore, amountInSek);
        }
    }
};

const getSynchronizeInputToDisplay = (
    reduxStore,
    amountInput,
    amountDisplay
) => {
    if (!amountInput || !amountDisplay) {
        return null;
    }
    amountDisplay.className = appendToStringOnce(
        amountDisplay.className,
        ' multi-currency-active'
    );
    return () => {
        const amountInSek = amountInput.value;
        renderElement(amountDisplay, reduxStore, amountInSek);
    };
};

const listenForAmountChangeInInput = (
    reduxStore,
    inputElementDataId,
    displayElementDataId
) => {
    const amountInput = document.querySelector(`[${inputElementDataId}]`);
    const amountDisplay = document.querySelector(`[${displayElementDataId}]`);

    if (!amountInput || !!amountInput.deregisterMultiCurrencyListeners) {
        return;
    }

    const synchronize = getSynchronizeInputToDisplay(
        reduxStore,
        amountInput,
        amountDisplay
    );

    if (synchronize === null) {
        return;
    }

    amountInput.addEventListener('keyup', synchronize);
    amountInput.addEventListener('focus', synchronize);
    amountInput.deregisterMultiCurrencyListeners = () => {
        amountInput.removeEventListener('keyup', synchronize);
        amountInput.removeEventListener('focus', synchronize);
    };
    synchronize();
};

const removeListeners = inputElementDataId => {
    const amountInput = document.querySelector(`[${inputElementDataId}]`);
    if (!amountInput || !amountInput.deregisterMultiCurrencyListeners) {
        return;
    }
    amountInput.deregisterMultiCurrencyListeners();
};

const renderVipModal = reduxStore => {
    const onModalLoad = () => {
        renderAllDisplays(reduxStore);
        listenForAmountChangeInInput(
            reduxStore,
            'data-submit-bid-amount-field',
            'data-multi-currency-display-max-bid-input'
        );
        listenForAmountChangeInInput(
            reduxStore,
            'data-submit-bid-amount-field',
            'data-multi-currency-display-bidding-price-input'
        );
    };
    const onModalClose = () => {
        removeListeners('data-submit-bid-amount-field');
    };
    const flightListener = defineComponent.component(
        createFlightListener(onModalLoad, onModalClose)
    );
    flightListener.attachTo(document);
};

const renderVipPage = reduxStore => {
    listenForAmountChangeInInput(
        reduxStore,
        'data-bid-amount-field',
        'data-multi-currency-display-vip-bid-input'
    );
};

const render = reduxStore => {
    if (!initData.currencies || initData.currencies.length === 0) {
        return;
    }
    renderVipModal(reduxStore);
    renderVipPage(reduxStore);
    renderAllDisplays(reduxStore);
};

export default {
    render
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/multi-currency/multi-currency-renderer.jsx